import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import ToolkitProvider, { Search,CSVExport  } from 'react-bootstrap-table2-toolkit';
import { NotificationManager } from "react-notifications";
import store from "../../store";
import { Loader } from "../../components/loader";
import { forceInputUppercase } from "../../utils/helper";
import DatePicker from "react-datepicker";
import moment from "moment";
import _  from 'lodash';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import classnames from 'classnames';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import { fetchCustomers, deleteCustomer } from '../../actions/customers';
import { Activity } from '../../components/activity';


const $ = window.$;
let selected_customers = [];
let selected_attributes = [];

const selectRow = {
  mode: "checkbox",
  onSelect: (row, isSelect, rowIndex, e) => {  
    console.log(row, isSelect);
    let arrayIndex = null;
    if(isSelect){   
    selected_customers.push(row);
    }
    else{
    arrayIndex =  _.findIndex(selected_customers, function(item) { return item.id == row.id; });
      if(arrayIndex >= 0){
        selected_customers.splice(arrayIndex,1);
      }   
    }
  },
  onSelectAll: (isSelect, rows, e) => {
    console.log(isSelect);
    console.log(rows);
    console.log(e);
    let arrayIndex = null;
      if(isSelect){ 
      selected_customers = [ ...rows, ...selected_customers ];
      }
      else{
        rows.forEach(item2 =>{   
            arrayIndex =  _.findIndex(selected_customers, function(item) { return item.id == item2.id; });
            if(arrayIndex >= 0){
              selected_customers.splice(arrayIndex,1);
            }         
        });      
      }
  },
};

const { SearchBar } = Search;
class Customers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user_role: "",
      loading: false,
      customerData: [],
      viewCustomer: {},
      allAttributes:[],
      user_group:"",
      finalCustomerData:[],
      all: false,
      firstname: false,
      lastname:false,
      city:false,
      state: false,
      zip_code: false,
      phone_primary: false,
      phone_primary_type : false,
      phone_secondary: false,
      phone_secondary_type: false,
      email: false,
      find_us: false,
      delivery_address_full: false,
      delivery_address: false,
      delivery_address_opt: false,
      delivery_town_city: false,
      delivery_state: false,
      createdAt: false,
      updatedAt: false,
      loadingDelete: false,
      customerId: null,
    };
  }

tableHeaderCustomerData = [

    { dataField: 'actions', text: 'Actions',
      formatter: this.buttonFormatter.bind(this),
       headerStyle: (selector, id) => {
        return { width: "75px", textAlign: "left" };
       }
    },
    {
      dataField: 'firstname', text: 'First Name', sort: true
    },
    {
      dataField: 'lastname', text: 'Last Name', sort: true
    },
    {
      dataField: 'phone_primary', 
      text: 'Primary Phone', 
      sort: true, 
      formatter: cell => <a href={`tel:${cell}`} className="hyperlink-phone-number">{cell}</a>
    },
    {
      dataField: 'state', text: 'State', sort: true
    },
    {
      dataField: 'zip_code', text: 'ZIP', sort: true
    },
    {
      dataField: 'address', text: 'Address', sort: true
    },
    {
      dataField: 'createdAt', text: 'Created Date', formatter: cell => moment(cell).format('YYYY-MM-DD'), sort: true
    },
    {
      dataField: 'createdBy', text: '', formatter: (cell, row) => {
        return ( 
          <Activity row={row} created={row.createdCustomer} updated={row.updatedCustomer} deleted={row.deletedCustomer}/>

        );
      }, sort: true,
      headerStyle: (selector, id) => {
        return { width: "50px", textAlign: "center" };
      }
    }

  ];
  
   buttonFormatter(cell, row) {
    return (
      <div>
          <span className="dropdown show">
          <span className="dropdown">
            <a
              href=""
              className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
              data-toggle="dropdown"
              aria-expanded="true"
            >
              <i className="la la-ellipsis-h"></i>
            </a>
            <div className="dropdown-menu dropdown-menu-right">
            <a
                className="dropdown-item"
                onClick={() => this.openViewModal(row.id)}
               >
                <i className="la la-eye"></i> View
              </a>   
               <a
                className="dropdown-item"
                onClick={(e) => { this.setDeleteCustomer(e,row.id) }}
               >
                <i className="la la-trash-o"></i> Delete
              </a>
            </div>
          </span>
        </span>
      </div>
    );
   }



  componentWillReceiveProps = nextProps => {
    if (nextProps.data.customersReducer.customerList && this.props.data.customersReducer.customerList !== nextProps.data.customersReducer.customerList) {
      let removeAttributes = ['updatedCustomer','createdCustomer','id'];
      this.setState({ customerData: nextProps.data.customersReducer.customerList });    
      let keys = Object.keys(nextProps.data.customersReducer.customerList[0]);
      removeAttributes.forEach(kk => {
       let arrayIndex =  _.findIndex(keys, function(item) { return item == kk; });
        if(arrayIndex >= 0){
          keys.splice(arrayIndex,1);
        }  
      });
      this.setState({ allAttributes : keys });      
    }  
    
    if (nextProps.data.customersReducer.deleteCustomer && this.props.data.customersReducer.deleteCustomer !== nextProps.data.customersReducer.deleteCustomer) {
        this.setState({ loadingDelete: false });
        $('#confirm_delete_modal').modal('hide');
        this.props.fetchCustomers();
        NotificationManager.success("Customer deleted successfully");
    }

    if (nextProps.data.customersReducer.deleteCustomerError && this.props.data.customersReducer.deleteCustomerError !== nextProps.data.customersReducer.deleteCustomerError) {
       if(nextProps.data.customersReducer.deleteCustomerError.message){   
             this.setState({ loadingDelete: false });
             $('#confirm_delete_modal').modal('hide');
             NotificationManager.error(nextProps.data.customersReducer.deleteCustomerError.message);
         }
    
    }
    
    if (
      this.props.currentUser !== nextProps.currentUser &&
      nextProps.currentUser
    ) {   
      this.setState({
        user_group: nextProps.currentUser.UserPetstores[0].Role.role_name
      });
    }
  };  


  componentDidMount() {
   this.props.fetchCustomers();
  }

   downloadCSV = async (args) => {
      try {      
      var data, filename, link;
      let csv = await  this.convertArrayOfObjectsToCSV({
          data: args.data
      });
      if (csv == null) return;
          filename = args.filename || 'customers.csv';

      if (!csv.match(/^data:text\/csv/i)) {
          csv = 'data:text/csv;charset=utf-8,' + csv;
      }
      data = encodeURI(csv);

      link = document.createElement('a');
      link.setAttribute('href', data);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.resetAllAttributes();
      $("#confirm_select_attributes_modal").modal("hide");

      } catch (error) {
        console.log('---Err--',error);

      }
 
   };


  convertArrayOfObjectsToCSV(args) {
  
      let result, ctr, keys, columnDelimiter, lineDelimiter, data;
      data = args.data || null;
      if (data == null || !data.length) {
          return null;
      }

      columnDelimiter = args.columnDelimiter || ',';
      lineDelimiter = args.lineDelimiter || '\n';

      keys = Object.keys(data[0]);

      result = '';
      result += keys.join(columnDelimiter);
      result += lineDelimiter; 
      data.forEach(function(item) {
        console.log('---item---',item);
          ctr = 0;
        
          keys.forEach(function(key) {        
              if (ctr > 0){        
              result += columnDelimiter;
              }
              if(item[key] &&  typeof item[key] === "string"){             
                let withoutCommas = item[key].replace(/,/g, ' ');           
                result += withoutCommas;                  
                ctr++;  
              }
              else{
                result += item[key];                  
                ctr++;  
              }   
          });
          result += lineDelimiter;
      });
      return result;
  };

  changeHeaderOrderCSV(selectAttributes){
   let selectedOrder = selectAttributes.data;
   let kk = selected_customers.map(item =>{
    const filteredUsers = Object.keys(item)
    .filter(key => selectedOrder.includes(key))
    .reduce((obj, key) => {
        obj[key] = item[key];
        return obj;
    }, {}); 
     return filteredUsers;  
   });
   this.setState({ finalCustomerData : kk });
   this.downloadCSV({data : kk});
  }

  confirmAttributes(){
    $("#confirm_select_attributes_modal").modal("show");
  }

  
  exportAllData(e){
    e.preventDefault();
    let selectedOrder = this.state.allAttributes;
    let selectedCustomersData = this.state.customerData.map(item =>{
     const filteredUsers = Object.keys(item)
     .filter(key => selectedOrder.includes(key))
     .reduce((obj, key) => {
         obj[key] = item[key];
         return obj;
     }, {}); 
      return filteredUsers;  
     });
     this.downloadCSV({data : selectedCustomersData}); 
  }
  
  openViewModal(custId) {
    const index = this.state.customerData.findIndex(c => { return c.id === custId });
    this.setState({ viewCustomer: this.state.customerData[index] });
    $('#view_customer').modal('show');
  }

  closeModal() {
    $('#view_customer').modal('hide');
  }

  setDeleteCustomer(e,id){
    e.preventDefault(); 
    this.setState({ customerId : id });
    $('#confirm_delete_modal').modal('show');
  }

  deleteCustomer(){
    this.setState({ loadingDelete: true });
    this.props.deleteCustomer(this.state.customerId);
  }

  selectAttributes(event){  
    let attrubute = event.target.value;
    let arrayIndex = null;  
    this.setState({ [attrubute] : event.target.checked });
    if(selected_customers && selected_customers.length > 0){
      if(attrubute == 'all'){
          if(event.target.checked === true){ 
       
            this.state.allAttributes.forEach(item=>{         
              this.setState({[item] : true});
            });
            selected_attributes = [...this.state.allAttributes]
          }
          else{       
            this.resetAllAttributes();
            selected_attributes = [];
          }
        
      }
      else{
        if(event.target.checked === true){   
          selected_attributes.push(attrubute);
        }
        else{       
          arrayIndex =  _.findIndex(selected_attributes, function(item) { return item == attrubute; });
          if(arrayIndex >= 0){
            selected_attributes.splice(arrayIndex,1);
          } 
          this.setState({ all : false });    
        }

      }
    }
    else{
      NotificationManager.error("Please select customers first");
      this.resetAllAttributes();
    }
   
  }

  resetAllAttributes(){
    this.state.allAttributes.forEach(item=>{
      this.setState({[item] : false});
    });
    this.setState({ all : false });
    selected_attributes =[];
  }


  render() {
    const {  viewCustomer } = this.state;
    return (
      <div>     
          <div className="m-form m-form--label-align-right m--margin-top-20 m--margin-bottom-30">
            <div className="row align-items-center">
              <div className="col-xl-6 order-2 order-xl-1">
              </div>
              <div className="col-xl-6 order-1 order-xl-2 m--align-right">
               <a href="#" className="btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill mr-2" onClick={(e) => {this.exportAllData(e)}}>
                  <span><i className ="la la-download"></i><span>Export All Data</span></span>
                </a> 
               <a href="#" className="btn btn-accent m-btn m-btn--custom m-btn--icon m-btn--air m-btn--pill" onClick={() => { $("#confirm_select_attributes_modal").modal("show"); }}>
                  <span><i className ="la la-download"></i><span>Export customize Data</span></span>
                </a> 
                <div className="m-separator m-separator--dashed d-xl-none"></div>
              </div>
            </div>
          </div>
        {this.state.loading ?
          <div className="col-md-12" style={{ textAlign: 'center' }}>
            <Loader width="100px" height="100px;" />
          </div>
          :
          <ToolkitProvider
            keyField="id"
            data={this.state.customerData}
            columns={this.tableHeaderCustomerData}
            search
            defaultSortDirection="asc"
            hover={true}
       
          >
            {
              props => (
                <div>
                  <div className='px-0 mb-4 search-bar'>           
                   <div className='col-lg-3 px-0 inner-addon right-addon'>
                      <i className="fas fa-search"></i>
                      <SearchBar {...props.searchProps} />
                    </div>
                  </div>
                  <BootstrapTable
                    classes="petTable"
                    {...props.baseProps}                 
                    pagination={paginationFactory()}   
                    selectRow={selectRow}              
                  />
                </div>
              )
            }
          </ToolkitProvider>
        } 
        <div
          className="modal fade"
          id="confirm_select_attributes_modal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="ConfirmationModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Select Attributes
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12">
                  <label className="m-checkbox">
                    <input type="checkbox" value={'all'} checked={this.state.all} onChange={e => this.selectAttributes(e)}/> All 
                      <span></span>
                    </label>
                  </div>

                </div>
                <div className="row">
                  <div className="col-6">
                    <div className="m-checkbox-list">
                       <label className="m-checkbox">
                          <input type="checkbox" value={'firstname'} checked={this.state.firstname} onChange={e => this.selectAttributes(e)}/> First Name
                          <span></span>
                        </label>
                        <label className="m-checkbox">
                          <input type="checkbox" value={'lastname'} checked={this.state.lastname} onChange={e => this.selectAttributes(e)}/> Last Name
                          <span></span>
                        </label>
                        <label className="m-checkbox">
                          <input type="checkbox" value={'address'} checked={this.state.address} onChange={e => this.selectAttributes(e)}/> Address
                          <span></span>
                        </label>
                        <label className="m-checkbox">
                          <input type="checkbox" value={'address_opt'} checked={this.state.address_opt} onChange={e => this.selectAttributes(e)}/> Address Option
                          <span></span>
                        </label>
                        <label className="m-checkbox">
                           <input type="checkbox"  value={'city'} checked={this.state.city} onChange={e => this.selectAttributes(e)}/> City
                           <span></span>
                        </label>
                        <label className="m-checkbox">
                          <input type="checkbox" value={'state'} checked={this.state.state} onChange={e => this.selectAttributes(e)}/> State
                          <span></span>
                        </label>
                        <label className="m-checkbox">
                          <input type="checkbox" value={'zip_code'} checked={this.state.zip_code} onChange={e => this.selectAttributes(e)}/> Zipcode
                          <span></span>
                        </label>
                        <label className="m-checkbox">
                          <input type="checkbox" value={'phone_primary'} checked={this.state.phone_primary} onChange={e => this.selectAttributes(e)}/> Phone Primary
                          <span></span>
                        </label>
                        <label className="m-checkbox">
                          <input type="checkbox" value={'phone_primary_type'} checked={this.state.phone_primary_type} onChange={e => this.selectAttributes(e)}/> Phone Primary Type
                          <span></span>
                        </label>
                        <label className="m-checkbox">
                          <input type="checkbox" value={'phone_secondary'} checked={this.state.phone_secondary} onChange={e => this.selectAttributes(e)}/> Phone Secondary
                          <span></span>
                        </label>
                        <label className="m-checkbox">
                          <input type="checkbox" value={'phone_secondary_type'} checked={this.state.phone_secondary_type} onChange={e => this.selectAttributes(e)}/> Phone Secondary Type
                          <span></span>
                        </label>  
                      </div>
                  </div>
                   <div className="col-6">
                    <div className="m-checkbox-list">
                        <label className="m-checkbox">
                          <input type="checkbox" value={'email'} checked={this.state.email} onChange={e => this.selectAttributes(e)}/> Email
                          <span></span>
                        </label>
                        <label className="m-checkbox">
                          <input type="checkbox" value={'find_us'} checked={this.state.find_us} onChange={e => this.selectAttributes(e)}/> Find Us
                          <span></span>
                        </label>
                        <label className="m-checkbox">
                          <input type="checkbox" value={'delivery_address_full'} checked={this.state.delivery_address_full}  onChange={e => this.selectAttributes(e)}/> Delivery Address Full
                          <span></span>
                        </label>
                        <label className="m-checkbox">
                          <input type="checkbox" value={'delivery_address'} checked={this.state.delivery_address} onChange={e => this.selectAttributes(e)}/> Delivery Address
                          <span></span>
                        </label>
                        <label className="m-checkbox">
                          <input type="checkbox" value={'delivery_address_opt'} checked={this.state.delivery_address_opt} onChange={e => this.selectAttributes(e)}/> Delivery Address Option
                          <span></span>
                        </label>
                        <label className="m-checkbox">
                          <input type="checkbox" value={'delivery_town_city'} checked={this.state.delivery_town_city} onChange={e => this.selectAttributes(e)}/> Delivery City
                          <span></span>
                        </label>
                        <label className="m-checkbox">
                          <input type="checkbox" value={'delivery_state'} checked={this.state.delivery_state} onChange={e => this.selectAttributes(e)}/> Delivery State
                          <span></span>
                        </label>
                          <label className="m-checkbox">
                          <input type="checkbox" value={'delivery_zip_code'} checked={this.state.delivery_zip_code} onChange={e => this.selectAttributes(e)}/>Delivery Zipcode
                          <span></span>
                         </label>
                        <label className="m-checkbox">
                          <input type="checkbox" value={'createdAt'} checked={this.state.createdAt} onChange={e => this.selectAttributes(e)}/> CreatedAt
                          <span></span>
                        </label>    
                        <label className="m-checkbox">
                          <input type="checkbox" value={'updatedAt'} checked={this.state.updatedAt} onChange={e => this.selectAttributes(e)}/> UpdatedAt
                          <span></span>
                        </label>                  
                   </div>
                  </div> 

                </div>
           
                </div>
              <div className="modal-footer">        
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={() => this.changeHeaderOrderCSV({ data: selected_attributes}) }
                      className="btn btn-primary m-btn--pill"
                    >
                      Confirm
                    </button>
                  </div>              
              </div>
            </div>
          </div>
        </div>       

        <div className="modal fade show" id="view_customer" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <form className="m-form">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel" style={{ alignSelf: 'center' }}>View Pet Customer</h5>
                  <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-xl-12">

                      <div className="form-group m-form__group row cust_view">
                        <label className="col-4 col-form-label">Name :</label>
                        <div className="col-8 col-form-label">
                          {viewCustomer.firstname} {viewCustomer.lastname}
                        </div>

                      </div>
                      <div className="form-group m-form__group row cust_view">
                        <label className="col-4 col-form-label">Email :</label>
                        <div className="col-8 col-form-label">
                          {viewCustomer.email}
                        </div>
                      </div>
                      <div className="form-group m-form__group row cust_view">
                        <label className="col-4 col-form-label">Address :</label>
                        <div className="col-8 col-form-label">
                          {viewCustomer.address}
                        </div>
                      </div>
                      <div className="form-group m-form__group row cust_view">
                        <label className="col-4 col-form-label">Address(optional) :</label>
                        <div className="col-8 col-form-label">
                          {viewCustomer.address_opt}
                        </div>
                      </div>
                      <div className="form-group m-form__group row cust_view">
                        <label className="col-4 col-form-label">State :</label>
                        <div className="col-8 col-form-label">
                          {viewCustomer.state}
                        </div>
                      </div>
                      <div className="form-group m-form__group row cust_view">
                        <label className="col-4 col-form-label">City :</label>
                        <div className="col-8 col-form-label">
                          {viewCustomer.city}
                        </div>
                      </div>
                      <div className="form-group m-form__group row cust_view">
                        <label className="col-4 col-form-label">ZIP Code :</label>
                        <div className="col-8 col-form-label">
                          {viewCustomer.zip_code}
                        </div>
                      </div>
                      <div className="form-group m-form__group row cust_view">
                        <label className="col-4 col-form-label">Primary Phone :</label>
                        <div className="col-8 col-form-label">
                          {viewCustomer.phone_primary}({viewCustomer.phone_primary_type})
                                </div>
                      </div>
                      <div className="form-group m-form__group row cust_view">
                        <label className="col-4 col-form-label">Secondary Phone :</label>
                        <div className="col-8 col-form-label">
                          {viewCustomer.phone_secondary}({viewCustomer.phone_secondary_type})
                                </div>
                      </div>
                      <div className="form-group m-form__group row cust_view">
                        <label className="col-4 col-form-label">How find us? :</label>
                        <div className="col-8 col-form-label">
                          {viewCustomer.find_us}
                        </div>
                      </div>
                      <div className="form-group m-form__group row">
                        <label className="col-4 col-form-label">Created at :</label>
                        <div className="col-8 col-form-label">
                          {moment(viewCustomer.createdAt).format('YYYY-MM-DD')}
                        </div>
                      </div>

                    </div>
                  </div>
                </div>


               


                <div className="modal-footer">
                  <div className="row">
                  </div>
                </div>

              </form>
            </div>

          </div>
        </div>
        
        <div
          className="modal fade"
          id="confirm_delete_modal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="ConfirmationModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Confirm to delete
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>
                  Are you sure you want to delete this customer ?
                </p>
              </div>
              <div className="modal-footer">
                {this.state.loadingDelete == false ? (
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      onClick={() => this.deleteCustomer()}
                      className="btn btn-primary m-btn--pill"
                    >
                      Confirm
                    </button>
                  </div>
                ) : (
                  <div className="center-row">
                    <Loader size={50} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

      </div>

    );
  }
}

  const mapStateToProps = state => ({
    user: state.cognito.user,
    petShop: state.petShopReducer,
    data: state,
    currentUser: state.userReducer.currentUser
  });

  const mapDispatchToProps = dispatch => ({
    fetchCustomers: () => {
      dispatch(fetchCustomers());
    },
    deleteCustomer: (id) => {
      dispatch(deleteCustomer(id));
    }
  });

  export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(Customers)
  );